import React, { useCallback } from 'react';
import { withTranslation } from 'react-i18next';
import { Box, Button, Backdrop, Modal, Typography } from '@mui/material';

import { CloseIcon } from '@icons';
import { ReactComponent as PrivacyIcon } from '@public/images/ek/privacy.svg';
import PdfViewer from './PdfViewer';

import { ModalView } from './interfaces';
import { useStyles } from './styles';

const PolicyModalView = ({
  file,
  open,
  disabled,
  isRead,
  handleScroll,
  onClose,
  onClick,
  isAccepted,
  t: translate,
}: ModalView) => {
  const classes = useStyles();

  return (
    <Modal
      sx={classes.root}
      open={open}
      components={{ Backdrop }}
      hideBackdrop={isAccepted}
    >
      <Box component="div" sx={classes.container}>
        {isAccepted ? (
          <CloseIcon sx={classes.closeIcon} onClick={onClose} />
        ) : null}
        <Box component="div" sx={classes.iconContainer}>
          <PrivacyIcon />
        </Box>
        <Typography sx={classes.title}>
          {translate('agreement.title')}
        </Typography>
        <Box sx={classes.pdf} onScroll={handleScroll}>
          <PdfViewer file={file} />
          {isRead ? null : <Box sx={classes.overlay} />}
        </Box>

        {!isAccepted ? (
          <Button sx={classes.button} onClick={onClick} disabled={disabled}>
            {translate('agreement.accept')}
          </Button>
        ) : null}
      </Box>
    </Modal>
  );
};

export default withTranslation()(PolicyModalView);
